import API from "apiInstance";
import { toast } from "react-toastify";

export const makeDonation = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donation",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const makeDonationProject = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/donation/donate-project",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donationPerNGO = async ({ id }) => {
  try {
    const response = await API({
      method: "get",
      url: `/api/donation/donation-per-ngo/${id}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donationPerProject = async ({ id }) => {
  try {
    const response = await API({
      method: "get",
      url: `/api/donation/donation-per-project/${id}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donationAmountPerProject = async (body) => {
  try {
    const response = await API({
      method: "get",
      url: "/api/donation/total-per-project",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donationAmountPerNGO = async (body) => {
  try {
    const response = await API({
      method: "get",
      url: "/api/donation/total-per-ngo",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const donationCountPerNGO = async (body) => {
  try {
    const response = await API({
      method: "get",
      url: "/api/donation/count",
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
